import { z } from 'zod';
import { retrievalResDto } from './retrieval.res.dto';

// the advanced retrieval in its post-transition shape
export const setRetrievalStatusResDto = retrievalResDto;
export type SetRetrievalStatusResDto = z.infer<typeof setRetrievalStatusResDto>;
